import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "ghippo-top-nav" }
const _hoisted_2 = { class: "ghippo-top-nav_left" }
const _hoisted_3 = { class: "ghippo-top-nav_right" }

import { type ShortcutMenus } from '@daocloud-proto/ghippo/v1alpha1/productnav.pb';
import { type PropType } from 'vue';
import AnakinNavItem from './AnakinNavItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopNav',
  props: {
  shortcutMenus: {
    type: Object as PropType<ShortcutMenus>,
    default: () => ({}),
  },
},
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.shortcutMenus.left, (nav) => {
        return (_openBlock(), _createBlock(AnakinNavItem, {
          key: (nav?.name || '') + nav?.url,
          "is-top-nav": "",
          nav: nav
        }, null, 8, ["nav"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.shortcutMenus.right, (nav) => {
        return (_openBlock(), _createBlock(AnakinNavItem, {
          key: (nav?.name || '') + nav?.url,
          "is-top-nav": "",
          nav: nav
        }, null, 8, ["nav"]))
      }), 128))
    ])
  ]))
}
}

})